import React, { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../../common/loader/Loader";
import oidcManager from "../../utils/oidcManager";
import { User } from "oidc-client-ts";
import {
  ACCESS_TOKEN_COOKIE,
  ID_TOKEN_COOKIE,
  PREVIOUS_PATH_KEY,
  REFRESH_TOKEN_COOKIE,
} from "../../constants";
import { useDispatch } from "react-redux";
import { setUser } from "../../store/authProviderSlice";
import useAuthenticationTokens from "../../hooks/useAuthenticationTokens";

const OidcProviderCallback: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setToken } = useAuthenticationTokens();

  useEffect(() => {
    oidcManager
      .signinRedirectCallback()
      .then((user: User) => {
        // Store tokens securely
        if (user.access_token) {
          setToken(ACCESS_TOKEN_COOKIE, user.access_token);
        }
        if (user.refresh_token) {
          setToken(REFRESH_TOKEN_COOKIE, user.refresh_token);
        } else {
          console.warn("No refresh token in user object");
        }
        if (user.id_token) {
          setToken(ID_TOKEN_COOKIE, user.id_token);
        }

        dispatch(setUser(user));

        // Navigate to previous path
        const previousPath = sessionStorage.getItem(PREVIOUS_PATH_KEY) ?? "/";
        navigate(previousPath, { replace: true });
      })
      .catch((error: unknown) => {
        console.error("Error handling redirect callback:", error);
        navigate("/", { replace: true });
      });
  }, [navigate, setToken, dispatch]);

  return <Loader fullPage />;
};

export default OidcProviderCallback;
